import { Heading, PageContainer, PageHeader, SimpleGrid } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';

import { ClientFeatures } from './ClientFeatures';
import { InternalFeatures } from './InternalFeatures';
import { Utilities } from './Utilities';

export function HomePage() {
  return (
    <PageContainer widescreen={false}>
      <PageHeader>
        <Heading>{T`homePage.title`}</Heading>
      </PageHeader>
      <SimpleGrid columns={6} columnGap={4} rowGap={6} gridAutoRows="1fr">
        <ClientFeatures />
        <Utilities />
      </SimpleGrid>
      <SimpleGrid columns={6} paddingTop={4}>
        <InternalFeatures />
      </SimpleGrid>
    </PageContainer>
  );
}
